import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M12.146 13.854c-.195-.195-.195-.512 0-.707s.512-.195.707 0L15 15.293V4.5c0-.276.223-.5.499-.5s.501.224.501.5v10.793l2.146-2.146a.5003.5003 0 0 1 .707 0 .4985.4985 0 0 1 0 .707l-3 3a.5003.5003 0 0 1-.707 0l-3-3zM1.146 6.146c-.195.195-.195.512 0 .707s.512.195.707 0L4 4.707V15.5c0 .276.223.5.499.5S5 15.776 5 15.5V4.707l2.146 2.146c.195.195.512.195.707 0a.4985.4985 0 0 0 0-.707l-3-3a.5003.5003 0 0 0-.707 0l-3 3z',
  ],
  height: 20,
  width: 20,
});
